import React, { useCallback, useContext } from 'react';
import { SaveAsPatchContext, ISaveAsPatchContext } from '../saveAsPatchModalState/saveAsPatchModalContext';
import { ModalToConfirm } from 'components/ModalWindows/ModalToConfirm';
import ModalSentError from 'components/ModalWindows/ModalSentError';
import classNames from 'classnames';
import style from './ModalWindows.module.scss';

interface IProps {
	onCloseModal: () => void;
}

export const ModalWindows: React.FC<IProps> = ({ onCloseModal }) => {
	const { changeTypeOfModalWindow, typeOfModalWindow } = useContext<ISaveAsPatchContext>(SaveAsPatchContext);
	const containerClasses = classNames(style.container, { [style.visible]: typeOfModalWindow });

	const handleCloseModal = useCallback(() => {
		changeTypeOfModalWindow(null);
	}, []);

	return (
		<div className={containerClasses} data-test="ModalWindows">
			{typeOfModalWindow === 'toConfirmFieldsClearing' && (
				<ModalToConfirm
					onConsentEvent={onCloseModal}
					onFailureEvent={handleCloseModal}
					isVisible={true}
					description="cancelSaveInfo"
				/>
			)}
			{typeOfModalWindow === 'error' && (
				<ModalSentError onConsentEvent={handleCloseModal} isVisible={true} description="errorWhileSaving" />
			)}
		</div>
	);
};
